import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "missing-rates-modal-book",
  "data-toggle": "modal"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "missing-rates-modal-book-title"
  }, " Missing rates "),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-dark fs-5 fw-bold" }, " Worker rates ", -1)
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Skill "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Standard")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Weekend")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Night Bonus")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Level Bonus")
      ])
    ])
  ])
], -1)
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "text-start fs-6 text-dark" }
const _hoisted_15 = {
  key: 0,
  class: "text-start fs-6 text-dark"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Level : ")
const _hoisted_17 = { class: "text-dark opacity-90 fs-6" }
const _hoisted_18 = {
  key: 1,
  class: "h-1px w-100 bg-secondary my-5"
}
const _hoisted_19 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-dark fs-5 fw-bold" }, " Client rates ", -1)
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Skill "),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Standart")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Weekend")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
        /*#__PURE__*/_createElementVNode("span", null, "Night Bonus")
      ])
    ])
  ])
], -1)
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start fs-6 text-dark" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Proceed without ")
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 0,
  class: "spinner-border me-2 spinner-border-sm"
}
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Save and book ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.workerRate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("table", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.skillName), 1),
                              (_ctx.levelName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    _hoisted_16,
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.levelName), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              min: "0",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workerRate.standard) = $event)),
                              class: "form-control w-80px h-30px"
                            }, null, 512), [
                              [_vModelText, _ctx.workerRate.standard]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              min: "0",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workerRate.weekend) = $event)),
                              class: "form-control w-80px h-30px"
                            }, null, 512), [
                              [_vModelText, _ctx.workerRate.weekend]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                min: "0",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workerRate.night) = $event)),
                                class: "form-control w-80px h-30px"
                              }, null, 512), [
                                [_vModelText, _ctx.workerRate.night]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                min: "0",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workerRate.level) = $event)),
                                class: "form-control w-80px h-30px"
                              }, null, 512), [
                                [_vModelText, _ctx.workerRate.level]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.workerRate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.companyRate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("table", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.skillName), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              min: "0",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyRate.standard) = $event)),
                              class: "form-control w-80px h-30px"
                            }, null, 512), [
                              [_vModelText, _ctx.companyRate.standard]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              min: "0",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.companyRate.weekend) = $event)),
                              class: "form-control w-80px h-30px"
                            }, null, 512), [
                              [_vModelText, _ctx.companyRate.weekend]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                min: "0",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.companyRate.night) = $event)),
                                class: "form-control w-80px h-30px"
                              }, null, 512), [
                                [_vModelText, _ctx.companyRate.night]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                disabled: _ctx.loading,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.bookUser && _ctx.bookUser(...args))),
                class: "me-4 h-40px d-flex justify-content-center align-items-center btn btn-secondary"
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                  : _createCommentVNode("", true),
                _hoisted_29
              ], 8, _hoisted_27),
              _createElementVNode("button", {
                disabled: _ctx.loading,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleSaveRatesAndBook && _ctx.handleSaveRatesAndBook(...args))),
                class: "h-40px d-flex justify-content-center align-items-center btn btn-primary"
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31))
                  : _createCommentVNode("", true),
                _hoisted_32
              ], 8, _hoisted_30)
            ])
          ])
        ])
      ])
    ])
  ]))
}